import {
  createFileRoute,
  Link,
  Outlet,
  useLocation,
  redirect,
} from "@tanstack/react-router";
import { PageHeader } from "@/components/AppShell";
import { hasRole } from "@/lib/auth-store";

export const Route = createFileRoute("/reports")({
  beforeLoad: ({ context }) => {
    if (!hasRole(context.user, "cashier")) {
      throw redirect({ to: "/" });
    }
  },
  head: () => ({
    meta: [
      { title: "Reports" },
      { name: "description", content: "Daily sales and cashbook reports." },
    ],
  }),
  component: ReportsLayout,
});

function ReportsLayout() {
  const loc = useLocation();
  const tabs = [
    { to: "/reports", label: "Sales Sheet" },
    { to: "/reports/cashbook", label: "Cashbook" },
    { to: "/reports/closed", label: "Closed Days" },
  ];
  return (
    <div>
      <PageHeader
        title="Daily Report"
        subtitle={new Date().toLocaleDateString()}
      />
      <div className="flex gap-1 border-b border-border px-4">
        {tabs.map((t) => {
          const active = loc.pathname === t.to;
          return (
            <Link
              key={t.to}
              to={t.to}
              className={`relative px-3 py-3 text-sm font-medium min-h-[44px] flex items-center ${active ? "text-primary" : "text-muted-foreground"}`}
            >
              {t.label}
              {active && (
                <span className="absolute inset-x-3 -bottom-px h-0.5 bg-primary" />
              )}
            </Link>
          );
        })}
      </div>
      <Outlet />
    </div>
  );
}
